module.exports = __webpack_public_path__ + "static/banner-home-682f5e870404f5ee420a30b3dd682b8a.jpg";